import { createSlice, current } from '@reduxjs/toolkit';

import ImportTableService from '../../../services/importTableService';
import { showMsg } from '../../../services/library';

const deleteImport = async ({ dealerId, vehId, vehName, dealer }) => {
  try {
    const response = await ImportTableService.deleteVehicle({ dealerId, vehId });
    if (response.status) {
      const message = [
        `Import and Mavis deleted permanently.`,
        `Vehicle: ${vehName}`,
        `Dealership: ${dealer}`
      ];
      showMsg(message, 'success');
    } else {
      showMsg(response.errors, 'error');
    }
  } catch (error) {
    showMsg(error, 'error');
  }
};

const importSlice = createSlice({
  name: 'importSlice',
  initialState: {
    data: [],
    displayLoader: true,
    isDataLoaded: false,
    importDelete: []
  },
  reducers: {
    handleData: (state, action) => {
      state.data = action.payload;
    },
    handleDisplayLoader: (state, action) => {
      state.displayLoader = action.payload;
    },
    handleIsDataLoaded: (state, action) => {
      state.isDataLoaded = action.payload;
    },
    addToQ: {
      // ADD_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        state.importDelete = [...importDelete, action.payload];
      },
      prepare(e) {
        return { payload: e };
      }
    },
    removeFromQ: {
      // REMOVE_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        const { vehId, dealerId } = action.payload;
        state.importDelete = importDelete.filter(x => x.vehId !== vehId && x.dealerId !== dealerId);
      },
      prepare(e) {
        return { payload: e };
      }
    },
    doDelete: {
      // DO_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        const { vehId, dealerId } = action.payload;

        let delNode = importDelete.find(x => x.vehId === vehId && x.dealerId === dealerId);
        if (delNode) {
          deleteImport(delNode);
        }
        state.importDelete = [...importDelete.filter(p => p.vehId !== vehId && p.dealerId !== dealerId)];
      },
      prepare(e) {
        return { payload: e };
      }
    }
  }
});

export const {
  handleData,
  handleDisplayLoader,
  handleIsDataLoaded,
  addToQ,
  removeFromQ,
  doDelete,
  importDelete
} = importSlice.actions;

export default importSlice.reducer;
